<template>
  <div class="privacy-page">
    <div v-html="richText"></div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      richText: '',
    };
  },
  activated() {
    this.getRichText();
  },
  methods: {
    getRichText() {
      requestApi('/v3/api/site/about/', {
        type: 1,
      }).then(res => {
        this.richText = res.content;
		console.log(this.richText)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy-page {
  padding: 30px;
}
</style>
